import React from 'react';

interface SavedViewShareLinkIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const SavedViewShareLinkIcon: React.FC<SavedViewShareLinkIconProps> = ({
  color = '#909090',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.1354 9.07869L12.4779 10.4205C12.7429 10.6948 12.8895 11.0623 12.8862 11.4436C12.8829 11.825 12.7299 12.1898 12.4602 12.4595C12.1905 12.7292 11.8257 12.8822 11.4444 12.8855C11.063 12.8888 10.6956 12.7422 10.4212 12.4772L7.48595 9.54196C7.32631 9.38693 7.20496 9.19687 7.1315 8.98682C7.05804 8.77678 7.03449 8.55251 7.06272 8.33178C7.09094 8.11106 7.17017 7.89993 7.29412 7.71513C7.41807 7.53033 7.58335 7.37692 7.77686 7.26705L6.72959 6.21978C6.1206 6.68611 5.72179 7.37524 5.62086 8.1356C5.51994 8.89596 5.72516 9.66527 6.1914 10.2743C6.2721 10.38 6.36007 10.4798 6.45468 10.5732L9.39213 13.5063C9.93771 14.0519 10.6777 14.3584 11.4492 14.3584C12.2208 14.3584 12.9607 14.0519 13.5063 13.5063C14.0519 12.9607 14.3584 12.2208 14.3584 11.4492C14.3584 10.6777 14.0519 9.93772 13.5063 9.39214L11.47 7.35578C11.4874 7.94777 11.3731 8.53623 11.1354 9.07869Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.49371 2.49348C2.22356 2.76362 2.00926 3.08432 1.86306 3.43727C1.71685 3.79023 1.6416 4.16853 1.6416 4.55057C1.6416 4.93261 1.71685 5.31091 1.86306 5.66387C2.00926 6.01682 2.22356 6.33753 2.49371 6.60766L4.51916 8.63239C4.501 8.04009 4.61451 7.45114 4.85153 6.90802L3.52207 5.57857C3.25711 5.30424 3.1105 4.93682 3.11382 4.55544C3.11713 4.17406 3.27011 3.80925 3.53979 3.53956C3.80947 3.26988 4.17429 3.1169 4.55567 3.11359C4.93705 3.11028 5.30447 3.25689 5.5788 3.52184L8.51407 6.45712C8.67371 6.61214 8.79506 6.8022 8.86852 7.01225C8.94198 7.2223 8.96553 7.44657 8.93731 7.66729C8.90908 7.88802 8.82985 8.09914 8.7059 8.28395C8.58195 8.46875 8.41667 8.62216 8.22316 8.73202L9.27043 9.7793C9.87942 9.31296 10.2782 8.62383 10.3792 7.86347C10.4801 7.10312 10.2749 6.33381 9.80862 5.72475C9.72792 5.61911 9.63995 5.51923 9.54534 5.42584L6.61007 2.49057C6.33994 2.22042 6.01923 2.00612 5.66628 1.85992C5.31332 1.71372 4.93502 1.63846 4.55298 1.63846C4.17094 1.63846 3.79264 1.71372 3.43968 1.85992C3.08673 2.00612 2.76603 2.22042 2.49589 2.49057L2.49371 2.49348Z"
      fill={color}
    />
  </svg>
);

export default SavedViewShareLinkIcon;
